export default {
    'id': 'Id',
    'nombre': 'Name',
    'telefono': 'Phonenumber',
    'codigo': 'Code',
    'email': 'Email',
    'activo': 'Active',
    'estado': 'State',
    'descripcion': 'Description',
    'usuario': 'User',
    'clave': 'Password',
    'all' : 'All',   
    'false':'No',
    'true':'Yes',
    'rows-per-page' : 'Rows per page:',
    'rules': {
        'required': 'The field is required',
        'email': 'The field does not comply with the correct format'
    },
    'home': {
        'titulo': 'Welcome',
        'parrafo': 'You have correctly installed the ITI template to streamline new software developments with .Net (Core) and VueJS technology. Before starting, we invite you to consult all the information put at your disposal in the start guides.',
        'enlaces': 'Links of interest',
        'front': 'Web Start Guide',
        'back': 'Backend Start Guide',
    },
    'menu': {
        'seguridad': 'Security',
        'usuarios': 'Users',
        'roles': 'Roles',
        'administracion': 'Administration',
        'tareas-programadas': 'Scheduled Tasks',
        'insylay': 'Insylay Portal'
    },
    'menuavatar': {
        'perfil': 'Profile',
        'salir': 'Exit',
    },
    'maestros': {
        'buscar': 'Search',
        'descargar': 'Download',
        'no-results': 'No result for search',
        'activo': 'Active',
        'admin': 'Admin',
        'editar': 'Edit',
        'eliminar': 'Remove',
    },
    'algoritmo': {
        'algoritmo': 'Algorithm',
        'algoritmos': 'Algorithms',
        'codigo': 'Code',
        'descripcion': 'Description',
        'imagen': 'Docker image',
        'estado': 'State',
        'registrado': 'Registered',
        'punto-entrada': 'entry point',
        'variables-entorno': 'Environment variables',
        'nombre-modulo': 'Module name',
        'entrada': 'Input',
        'salida': 'Output',
        'slots': 'Container Slots',
        'categorias': 'Categories',
        'tipo-lanzamiento': 'Launch type'
    },
    'maestro-usuarios': {
        'usuario': 'User',
        'email': 'Email',
        'clave': 'Password',
        'repetir-clave': 'Repeat password',
        'cambiar-clave': 'Change password',
        'roles': 'Roles',
        'id-externo':'External ID',
        'razon-social':'Business name',
        'provincia':'Province',
        'direccion':'Address',
        'poblacion':'Location', 
        'codigo-postal':'Postal Code',
        'pais':'Country',
        'cif':'CIF',
                
    },
    'maestro-roles': {
        'rol': 'Rol',
        'nombre': 'Name',
    },
    'maestro-tareas': {
        'tareas-programadas': 'Scheduled Tasks',
        'tarea-programada': 'Scheduled Task',
        'timeout': 'Timeout (min)',
        'tipo-tarea': 'Task type',
        'inicio-automatico': 'Automatic start',
        'cada': 'Each',
        'minutos': 'minutes',
        'horas': 'hours',
        'cron': 'Periodicity',
        'iniciar': 'Start',
        'detener': 'Stop',
        'en-ejecucion': 'Running',
    },
    'maestro-configuracion': {
        'codigo-cnae': 'Cnae Code',
        'codigo-ler': 'Ler Code',
        'sector': 'Sector',
        'tipo-unidad': 'Unit Type',
        'tipo-campo': 'Field Type',
        'asociacion' : 'Association',
        'categoria' : 'Category',
        'categoria-primer-nivel' : 'Category first level',
        'categoria-segundo-nivel' : 'Category second nivel',
        'categoria-tercer-nivel' : 'Category third nivel',
        'categoria-cuarto-nivel' : 'Category fourth nivel',
        'primer-nivel' : 'First level',
        'segundo-nivel' : 'Second level',
        'tercer-nivel' : 'Third level',
        'cuarto-nivel' : 'Fourth level',
        'codigo': 'Code',
        'descripcion': 'Description',
        'tipo': 'Type'
    },    
    'mensajes': {
        'save-ok': 'Changes made correctly',
        'ok': ' saved correctly',
        'confirmar': 'Confirm',
        'pregunta-borrar': 'Are you sure you want to eliminate "',
        'error-session' : 'The session has expired',
        'error-categoria-padre-vacia': 'The parent category cannot be empty'

    },
};
